// extracted by mini-css-extract-plugin
export var logo = "_4x-2";
export var logoWrapper = "_4x-1";
export var strip = "_4x-0";